import { render, staticRenderFns } from "./ClassroomAuthorize.vue?vue&type=template&id=5bc318b0&"
import script from "./ClassroomAuthorize.vue?vue&type=script&lang=ts&"
export * from "./ClassroomAuthorize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports